import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import paletteGenerator from '@bobthered/tailwindcss-palette-generator';
import { ThemeProvider } from '@emotion/react';
import { useStaticQuery } from 'gatsby';
import chakraTheme from '../theme/chakra-theme';
import { extendTheme, ThemeProvider as ChakraThemeProvider, GlobalStyle, PortalManager } from '@chakra-ui/react';
import CSSReset from './CSSReset';
import { readableColor } from 'polished';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Root = _ref => {
  let {
    children
  } = _ref;
  const {
    theme
  } = useStaticQuery(query);
  const brandColor = paletteGenerator(theme.brand_color);
  const baseColor = paletteGenerator(theme.base_color);
  const colorVal = readableColor(theme.base_color);
  const darkTheme = colorVal === '#fff';
  const colorMode = darkTheme ? 'dark' : 'light';
  const combinedTheme = extendTheme({
    initialColorMode: colorMode,
    useSystemColorMode: false,
    colors: {
      brand: _objectSpread({}, brandColor.primary),
      base: _objectSpread({}, baseColor.primary)
    },
    config: theme.config
  }, chakraTheme);
  theme.colorMode = colorMode;
  return ___EmotionJSX(ChakraThemeProvider, {
    theme: combinedTheme
  }, ___EmotionJSX(ThemeProvider, {
    theme: theme
  }, ___EmotionJSX(CSSReset, null), ___EmotionJSX(GlobalStyle, null), ___EmotionJSX(PortalManager, null, children)));
};
export default Root;
const query = "2402200562";